import { render, staticRenderFns } from "./RoleRow.vue?vue&type=template&id=bf2dcb24&"
import script from "./RoleRow.vue?vue&type=script&lang=js&"
export * from "./RoleRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports